import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type DrawerState =
  | { open: false }
  | { open: true; operation: 'create' }
  | {
      open: true;
      operation: 'update';
      templateId: string;
    };

const Context = createContext<
  | {
      drawerState: DrawerState;
      setDrawerState: Dispatch<SetStateAction<DrawerState>>;
    }
  | undefined
>(undefined);

export const useOrganizationTemplateDrawerState = (): NonNullable<
  ContextType<typeof Context>
> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      'useOrganizationTemplateDrawerState must be used within OrganizationTemplateDrawerStateProvider.',
    );
  }
  return context;
};

export const OrganizationTemplateDrawerStateProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [drawerState, setDrawerState] = useState<DrawerState>({ open: false });

  return (
    <Context.Provider value={{ drawerState, setDrawerState }}>
      {children}
    </Context.Provider>
  );
};
